// extracted by mini-css-extract-plugin
export var dialog = "_04593815104cfc4fb3b17c99be8000d9-css";
export var form = "_1f7cceb2fbf6bb4550b49df13c39e08e-css";